export default __webpack_public_path__ + "static/media/phone.cbae8f9f.svg";